<template>
  <svg viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5.6498" cy="11.9501" r="1.35" fill="currentColor" />
    <circle cx="11.9496" cy="11.9501" r="1.35" fill="currentColor" />
    <circle cx="18.2494" cy="11.9501" r="1.35" fill="currentColor" />
  </svg>
</template>
